import { Component, OnInit } from '@angular/core';
import { DepartmentBase } from '../department.base';

@Component({
  selector: 'dpto-97',
  templateUrl: './dpto97.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto97Component extends DepartmentBase {
  municipalities=[{"id":1113,"code":"97001","name":"Mit\u00fa","state":"1","department_code":"97"},{"id":1114,"code":"97161","name":"Caruru","state":"1","department_code":"97"},{"id":1115,"code":"97511","name":"Pacoa ","state":"1","department_code":"97"},{"id":1116,"code":"97666","name":"Taraira","state":"1","department_code":"97"},{"id":1117,"code":"97777","name":"Papunaua ","state":"1","department_code":"97"},{"id":1118,"code":"97889","name":"Yavarat\u00e9 ","state":"1","department_code":"97"}]
}
